const prefix = 'ORG/';

export const SET_ORG_LIST = `${prefix}SET_ORG_LIST`;

export default SET_ORG_LIST;
